import PropTypes from 'prop-types';

import { BackendState, BackendStateWithData } from '../../types';
import { TyreDTO } from '../../types/dto/TyreDTO';
import { TyreLOVDTO } from '../../types/dto/TyreLOVDTO';

//////////////////////////////////////////////////////////////////////////////////////////
// Misc shapes
//////////////////////////////////////////////////////////////////////////////////////////

export interface GetTyreSeccao {
    readonly data: TyreLOVDTO[];
}
export interface GetTyreSerie {
    readonly data: TyreLOVDTO[];
}
export interface GetTyreJante {
    readonly data: TyreLOVDTO[];
}
export interface GetTyreList {
    readonly data: TyreDTO[];
}

export interface GetTyreSeccaoState extends BackendStateWithData<TyreLOVDTO[]> { }
export interface GetTyreSerieState extends BackendStateWithData<TyreLOVDTO[]> { }
export interface GetTyreJanteState extends BackendStateWithData<TyreLOVDTO[]> { }
export interface GetTyreListState extends BackendStateWithData<TyreDTO[]> { }
export interface TyreContactState extends BackendState { }

export interface TyreState {
    readonly getTyreSeccao: GetTyreSeccaoState;
    readonly getTyreSerie: GetTyreSerieState;
    readonly getTyreJante: GetTyreJanteState;
    readonly getTyreList: GetTyreListState;
    readonly tyreContact: TyreContactState;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Action shapes
//////////////////////////////////////////////////////////////////////////////////////////

export const TyreActionPropTypes = PropTypes.shape({
    getTyreSeccaoRequest: PropTypes.func.isRequired,
    getTyreSeccaoSuccess: PropTypes.func.isRequired,
    getTyreSeccaoFailure: PropTypes.func.isRequired,

    getTyreSerieRequest: PropTypes.func.isRequired,
    getTyreSerieSuccess: PropTypes.func.isRequired,
    getTyreSerieFailure: PropTypes.func.isRequired,

    getTyreJanteRequest: PropTypes.func.isRequired,
    getTyreJanteSuccess: PropTypes.func.isRequired,
    getTyreJanteFailure: PropTypes.func.isRequired,

    getTyreListRequest: PropTypes.func.isRequired,
    getTyreListSuccess: PropTypes.func.isRequired,
    getTyreListFailure: PropTypes.func.isRequired,

    tyreContactRequest: PropTypes.func.isRequired,
    tyreContactSuccess: PropTypes.func.isRequired,
    tyreContactFailure: PropTypes.func.isRequired,
});
